// @ts-nocheck
import {
  Dialog as MDialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { FORTA_WHITE } from '../../../utils/colors';
import CloseIcon from '../../svgs/CloseIcon';
import { Themes } from '../../../constants';
import { getThemeColor } from '../../../utils/common';

import type { DialogProps as MDialogProps } from '@mui/material';

interface DragDropDialogProps extends MDialogProps {
  colorTheme?: Themes;
  coloredBackground?: boolean;
  title?: string;
  subTitle?: string;
}

const StyledDialog = styled(MDialog, {
  shouldForwardProp: (prop) => prop !== 'colorTheme',
})<DragDropDialogProps>(({ coloredBackground, colorTheme }: any) => ({
  '& .MuiDialog-paper': {
    width: 900,
    height: 600,
    backgroundColor: coloredBackground ? getThemeColor(colorTheme).primary : FORTA_WHITE,
    boxShadow: `0px 4px 4px ${getThemeColor(colorTheme).light2}`,
    borderRadius: '10px',
  },
  '& .MuiDialogContent-root': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
}));

function DragDropDialog(props: DragDropDialogProps) {
  const { open, children, title, subTitle, colorTheme = Themes.Primary, onClose } = props;
  return (
    <StyledDialog
      open={open}
      BackdropProps={{
        style: { backgroundColor: 'rgba(0, 0, 0, 0.4)', backdropFilter: 'blur(2px)' },
      }}
      fullScreen
      colorTheme={colorTheme}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingX: '1.5em',
          paddingTop: '1em',
        }}
      >
        <Box>
          {title && title.length && (
            <Typography variant="h6" fontWeight="bold" align="left">
              {title}
            </Typography>
          )}
          {subTitle && subTitle.length && <Typography align="left">{subTitle}</Typography>}
        </Box>
        <IconButton sx={{ p: 0 }} disableRipple onClick={onClose}>
          <CloseIcon color={getThemeColor(colorTheme).primary} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ position: 'relative' }}>{children}</DialogContent>
    </StyledDialog>
  );
}

export default DragDropDialog;
